import { render, staticRenderFns } from "./Groups.yaml?vue&type=template&id=706f840a&component"
import script from "./Groups.yaml?vue&type=script&lang=ts&component"
export * from "./Groups.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports